import { Autoplay, Grid, Navigation, Controller } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRef, useState } from "react";

import Text from "../../components/Text";
import consultationImage from "../../assets/images/cons-1.jpg";
import dietitianImage from "../../assets/images/coach-3.png";
import ConsultationCard from "../../components/ConsultationCard";
import consultationCardsInfo from "./consultationCardsInfo.json";
import Container from "../../components/Container";
import ShowAllLink from "../../components/ShowAllLink";
import useLocalStorage from "../../hooks/useLocalStorage";

const ShortConsultationSection = () => {
  const [movementValue, setMovementValue] = useState(0);

  const handleSlideMovement = (swiper) => {
    const movementPercent =
      (swiper.previousTranslate / swiper.width) * -150 + 30;
    if (movementPercent <= 100 && movementPercent >= -100)
      setMovementValue(movementPercent);
  };

  return (
    <div className="flex justify-center">
      <div className="w-full">
        <Container width={"w-full"} padding="p-0">
          <div className="heading pb-4 px-4">
            <Text
              text={"One-to-One Short Consultations"}
              component="h3"
              classes={"text-xl font-semibold"}
            />
          </div>
        </Container>

        <div className="cards py-4">
          <Swiper
            modules={[Controller, Grid, Navigation, Autoplay]}
            className="overflow-visible"
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            autoplay={{
              delay: 2000,
            }}
            spaceBetween={10}
            breakpoints={{
              1024: {
                slidesPerView: 3.5,
              },
              900: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2.3,
              },
              0: {
                slidesPerView: 1,
                grid: {
                  fill: "row",
                  rows: 8,
                },
              },
            }}
            onSliderMove={(swiper) => handleSlideMovement(swiper)}
            onAutoplay={(swiper) => handleSlideMovement(swiper)}
            onTouchMove={(swiper) => handleSlideMovement(swiper)}
            onNavigationNext={(swiper) => handleSlideMovement(swiper)}
            onNavigationPrev={(swiper) => handleSlideMovement(swiper)}
          >
            {consultationCardsInfo.map((card, index) => {
              return (
                <SwiperSlide
                  key={index}
                  className="px-4 transition-all duration-300"
                >
                  <ConsultationCard
                    card={card}
                    movementValue={movementValue}
                    dietitianImage={dietitianImage}
                    consultationImage={consultationImage}
                  />
                </SwiperSlide>
              );
            })}
            <div className="swiper-button-next bg-white h-12 w-12 top-1/4 border rounded-full shadow-lg after:text-lg after:content-['next'] after:text-secondary-800 after:font-bold"></div>
            <div className="swiper-button-prev bg-white h-12 w-12 top-1/4 border rounded-full shadow-lg after:text-lg after:content-['prev'] after:text-secondary-800 after:font-bold"></div>
          </Swiper>
        </div>
        <div className="px-4 text-[15px] py-5 text-[#e66553] font-semibold">
          <ShowAllLink text={"Show All(100+)"} to="/" />
        </div>
      </div>
    </div>
  );
};

export default ShortConsultationSection;
